<template>
	<section class="login p-fixed d-flex text-center bg-login">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="login-card card-block auth-body mr-auto ml-auto">
                        <div class="alert" role="alert" v-show="status.status !== ''" v-bind:class="{'alert-danger': status.status == 'Error', 'alert-warning': status.status == 'Processing', 'alert-success': status.status == 'Success'}">
                            <strong>{{status.status}}</strong> {{status.message}}
                        </div>
                        <form class="md-float-material" v-on:submit.prevent="processLogin">
                            <div class="auth-box">
                                <div class="logo-holder">
                                    <img src="../assets/logo.png" alt="logo.png">
                                </div>
                                <hr/>
                                <div class="input-group">
                                    <input type="email" name="email" v-model="login.email" class="form-control" placeholder="Email Address" required="required" />
                                    <span class="md-line"></span>
                                </div>
                                <div class="input-group">
                                    <input type="password" name="password" v-model="login.password" class="form-control" placeholder="Password">
                                    <span class="md-line"></span>
                                </div>
                                <div class="row m-t-25 text-left">
                                    <div class="col-12">
                                        <div class="checkbox-fade custom-green-checkbox">
                                            <label>
                                                <input type="checkbox" value="">
                                                <span class="cr"><i class="cr-icon icofont icofont-ui-check"></i></span>
                                                <span class="text-inverse">Remember me</span>
                                            </label>
                                        </div>
                                        <!-- <div class="forgot-phone text-right f-right">
                                            <a href="auth-reset-password.html" class="text-right f-w-600 text-inverse"> Forgot Password?</a>
                                        </div> -->
                                    </div>
                                </div>
                                <div class="row m-t-30">
                                    <div class="col-md-12">
                                        <button type="submit" style="background-color: #016734; color: white;" class="btn btn-md btn-block waves-effect text-center m-b-20">Sign in</button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<style scoped>
    .logo-holder{
        width: 130px !important;
    }
    .logo-holder img{
        width: 100% !important;
        margin: 0 auto;
    }
</style>
<script>

    //import {router} from '../router'

	export default{
		name: 'Login',
        data(){
            return{
                login:{
                    email: '',
                    password: ''
                },
                status: {
                    status: '',
                    message: ''
                }
            }
        },
        methods:{
            processLogin(){
                this.status.status = 'Processing'
                this.status.message = ''
                this.$store.dispatch('login', this.login)
                    .then((response)=>{
                        if(this.$store.getters.isLoggedIn){
                            this.status.status = 'Success'
                            this.status.message = 'Login successful, redirecting...'
                            // this.$router.push('/dashboard');
                            window.location.href = '/dashboard'
                        }
                    })
                    .catch((err)=>{
                        console.log(err)
                        this.$swal.close()
                        this.status.status = 'Error'
                        this.status.message = err.message

                        setTimeout(()=>{
                            this.status.status = ''
                        }, 3000)
                    })
            },

            logout: function(){
                this.$store.dispatch('logout')
            }
        },

        mounted(){
            this.logout()
        }

	}
</script>

<style scoped>
.custom-green-checkbox .cr {
  border-color: #016734;
}

.custom-green-checkbox input[type="checkbox"]:checked ~ .cr {
  background-color: #016734;
  border-color: #016734;
}

.custom-green-checkbox .cr-icon {
  color: #fff; 
}
</style>